import {DateTime} from "luxon"
import {zones} from "tzdata"

export const timezoneNames = Object.entries(zones)
  .filter(([_, v]) => Array.isArray(v))
  .map(([zoneName]) => zoneName.toString())
  .filter(zoneName => DateTime.local().setZone(zoneName).isValid)
  .sort((a, b) => a.localeCompare(b))

export const TZ_EUROPE_BERLIN = "Europe/Berlin"
